import { Box, Container, Grid } from "@mui/material";
import React from "react";
import Img1 from "./../assets/images/alberta/alberta_first.jpg";
import Img2 from "./../assets/images/alberta/alberta_second.jpg";
import Img3 from "./../assets/images/alberta/alberta_third.jpg";
import Img4 from "./../assets/images/alberta/alberta_four.jpg";
import Img5 from "./../assets/images/alberta/alberta_five.jpg";
import Img6 from "./../assets/images/alberta/alberta_six.jpg";
import Img7 from "./../assets/images/alberta/alberta_seven.jpg";
import projectImg from "./../assets/images/relatedprojects/harry.jpg";
import Contentimages from "../components/Contentimages";
import PostRealetedDates from "../components/PostRealetdDates";
import ProtfolioNavigation from "../components/ProtfolioNavigation";
import RelatedProjects from "../components/RelatedProjects";
import { Link } from "react-router-dom";
import { useDocumentMetaData } from "../components/useDocumentMetaData";

const Albertautilities = () => {
  const imageArray = [Img1, Img2, Img3, Img4, Img5, Img6, Img7];

  const relatedDates = [
    {
      title: "Torys LLP",
      url: "/portfolio_page/torys/",
      date: "September 27, 2012",
    },
    {
      title: "Petrobakken Energy Ltd",
      url: "/portfolio_page/petrobakken/",
      date: "September 26, 2012",
    },
    {
      title: "Arcan Resources",
      url: "/portfolio_page/arcan-resources/",
      date: "October 23, 2012",
    },
  ];

  const projects = [
    {
      title: "Harry Hays – Parks Canada",
      firm: "Government",
      image: projectImg, // Placeholder image URL
      link: "/portfolio_page/harry-hays-parks-canada-2/", // URL path or external link
    },
  ];

  useDocumentMetaData({
    title: "Alberta Utilities Commission Offices - MidWest Group",
    description:
      "MidWest Group completed the drywall partitions, bulkheads, ceilings, and acoustic solutions for Alberta Utilities Commission’s new offices at Eau Claire Tower, Calgary.",
    keywords:
      "Alberta Utilities Commission, Calgary offices, MidWest Group, drywall partitions, bulkheads, ceilings, acoustic solutions, Kasian, Govan Brown",
    canonical:
      "https://www.midwest-group.com/portfolio_page/alberta-utilities-commission/",
    author: "MidWest Group",
    ogTitle: "Alberta Utilities Commission Offices",
    ogDescription:
      "MidWest Group delivered drywall, ceilings, and acoustic installations for Alberta Utilities Commission's new offices in Calgary’s Eau Claire Tower.",
    ogImage: "https://www.midwest-group.com/static/media/alberta_five.bf7b591d41ca7a3bb23e.jpg",
    ogUrl:
      "https://www.midwest-group.com/portfolio_page/alberta-utilities-commission/",
    twitterTitle: "Alberta Utilities Commission Offices",
    twitterDescription:
      "Explore MidWest Group’s work completing drywall, bulkheads, ceilings, and acoustic solutions for Alberta Utilities Commission in Calgary.",
    twitterImage:
      "https://www.midwest-group.com/static/media/alberta_five.bf7b591d41ca7a3bb23e.jpg",
  });

  return (
    <>
      <div className="parent-div">
        <Container
          fixed
          className="parent-container"
          style={{ paddingLeft: "0px", paddingRight: "0px" }}
        >
          <Box>
            <Contentimages
              tab={"Calgary, Alberta"}
              heading={"Alberta Utilities Commission"}
              imageArray={imageArray}
            >
              <Link
                to={"http://www.auc.ab.ca/Pages/default.aspx"}
                target="_blank"
                className="navigation-link"
              >
                Alberta Utilities Commission (AUC)
              </Link>{" "}
              recently relocated into the new Eau Claire Tower in downtown
              Calgary. Designed by{" "}
              <Link
                to={"http://www.auc.ab.ca/Pages/default.aspx"}
                target="_blank"
                className="navigation-link"
              >
                Kasian
              </Link>
              , AUC’s new offices on floors 12 and 14 are light and functional,
              from the offices to the meeting rooms to the Hearing Room. Under
              contract to{" "}
              <Link
                to={"https://govanbrown.com/"}
                target="_blank"
                className="navigation-link"
              >
                Govan Brown,
              </Link>{" "}
              MidWest completed drywall partitions, bulkheads and ceilings,
              installation of base building ceiling tile, and supply and install
              of High Cloud perimeter trim. Plenum barriers were installed to
              increase sound absorption, as well as Barymat in the wall cavities
              behind all electrical and data outlets.
            </Contentimages>
            <Grid container paddingBottom={10}></Grid>
            <PostRealetedDates relatedDates={relatedDates} />
            <ProtfolioNavigation
              backUrl="/portfolio_page/sheraton-eau-claire/"
              nextUrl="/portfolio_page/esker-art-gallery-2/"
            />
            <RelatedProjects projects={projects} />
          </Box>
        </Container>
      </div>
    </>
  );
};

export default Albertautilities;
